module.exports = __webpack_public_path__ + "img/5f_r_musashi@2x.0f4a2934.jpg";